/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as RedirectingRouteImport } from './routes/redirecting'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as AuthLayoutRouteImport } from './routes/_auth-layout'
import { Route as DashboardIndexRouteImport } from './routes/_dashboard.index'
import { Route as DashboardAgentsRouteImport } from './routes/_dashboard.agents'
import { Route as AuthLayoutLoginRouteImport } from './routes/_auth-layout.login'
import { Route as DashboardAgentsIndexRouteImport } from './routes/_dashboard.agents.index'
import { Route as DashboardAgentsNewRouteImport } from './routes/_dashboard.agents.new'
import { Route as DashboardAgentsAgentIdIndexRouteImport } from './routes/_dashboard.agents.$agentId.index'
import { Route as DashboardAgentsAgentIdTestRouteImport } from './routes/_dashboard.agents.$agentId.test'

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const RedirectingRoute = RedirectingRouteImport.update({
  id: '/redirecting',
  path: '/redirecting',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLayoutRoute = AuthLayoutRouteImport.update({
  id: '/_auth-layout',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAgentsRoute = DashboardAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => DashboardRoute,
} as any)
const AuthLayoutLoginRoute = AuthLayoutLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const DashboardAgentsIndexRoute = DashboardAgentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardAgentsRoute,
} as any)
const DashboardAgentsNewRoute = DashboardAgentsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => DashboardAgentsRoute,
} as any)
const DashboardAgentsAgentIdIndexRoute =
  DashboardAgentsAgentIdIndexRouteImport.update({
    id: '/$agentId/',
    path: '/$agentId/',
    getParentRoute: () => DashboardAgentsRoute,
  } as any)
const DashboardAgentsAgentIdTestRoute =
  DashboardAgentsAgentIdTestRouteImport.update({
    id: '/$agentId/test',
    path: '/$agentId/test',
    getParentRoute: () => DashboardAgentsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof DashboardIndexRoute
  '/redirecting': typeof RedirectingRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/login': typeof AuthLayoutLoginRoute
  '/agents': typeof DashboardAgentsRouteWithChildren
  '/agents/new': typeof DashboardAgentsNewRoute
  '/agents/': typeof DashboardAgentsIndexRoute
  '/agents/$agentId/test': typeof DashboardAgentsAgentIdTestRoute
  '/agents/$agentId/': typeof DashboardAgentsAgentIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof DashboardIndexRoute
  '/redirecting': typeof RedirectingRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/login': typeof AuthLayoutLoginRoute
  '/agents/new': typeof DashboardAgentsNewRoute
  '/agents': typeof DashboardAgentsIndexRoute
  '/agents/$agentId/test': typeof DashboardAgentsAgentIdTestRoute
  '/agents/$agentId': typeof DashboardAgentsAgentIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth-layout': typeof AuthLayoutRouteWithChildren
  '/_dashboard': typeof DashboardRouteWithChildren
  '/redirecting': typeof RedirectingRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/_auth-layout/login': typeof AuthLayoutLoginRoute
  '/_dashboard/agents': typeof DashboardAgentsRouteWithChildren
  '/_dashboard/': typeof DashboardIndexRoute
  '/_dashboard/agents/new': typeof DashboardAgentsNewRoute
  '/_dashboard/agents/': typeof DashboardAgentsIndexRoute
  '/_dashboard/agents/$agentId/test': typeof DashboardAgentsAgentIdTestRoute
  '/_dashboard/agents/$agentId/': typeof DashboardAgentsAgentIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/redirecting'
    | '/unauthorized'
    | '/login'
    | '/agents'
    | '/agents/new'
    | '/agents/'
    | '/agents/$agentId/test'
    | '/agents/$agentId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/redirecting'
    | '/unauthorized'
    | '/login'
    | '/agents/new'
    | '/agents'
    | '/agents/$agentId/test'
    | '/agents/$agentId'
  id:
    | '__root__'
    | '/_auth-layout'
    | '/_dashboard'
    | '/redirecting'
    | '/unauthorized'
    | '/_auth-layout/login'
    | '/_dashboard/agents'
    | '/_dashboard/'
    | '/_dashboard/agents/new'
    | '/_dashboard/agents/'
    | '/_dashboard/agents/$agentId/test'
    | '/_dashboard/agents/$agentId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthLayoutRoute: typeof AuthLayoutRouteWithChildren
  DashboardRoute: typeof DashboardRouteWithChildren
  RedirectingRoute: typeof RedirectingRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/redirecting': {
      id: '/redirecting'
      path: '/redirecting'
      fullPath: '/redirecting'
      preLoaderRoute: typeof RedirectingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth-layout': {
      id: '/_auth-layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/': {
      id: '/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/agents': {
      id: '/_dashboard/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof DashboardAgentsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_auth-layout/login': {
      id: '/_auth-layout/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLayoutLoginRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_dashboard/agents/': {
      id: '/_dashboard/agents/'
      path: '/'
      fullPath: '/agents/'
      preLoaderRoute: typeof DashboardAgentsIndexRouteImport
      parentRoute: typeof DashboardAgentsRoute
    }
    '/_dashboard/agents/new': {
      id: '/_dashboard/agents/new'
      path: '/new'
      fullPath: '/agents/new'
      preLoaderRoute: typeof DashboardAgentsNewRouteImport
      parentRoute: typeof DashboardAgentsRoute
    }
    '/_dashboard/agents/$agentId/': {
      id: '/_dashboard/agents/$agentId/'
      path: '/$agentId'
      fullPath: '/agents/$agentId/'
      preLoaderRoute: typeof DashboardAgentsAgentIdIndexRouteImport
      parentRoute: typeof DashboardAgentsRoute
    }
    '/_dashboard/agents/$agentId/test': {
      id: '/_dashboard/agents/$agentId/test'
      path: '/$agentId/test'
      fullPath: '/agents/$agentId/test'
      preLoaderRoute: typeof DashboardAgentsAgentIdTestRouteImport
      parentRoute: typeof DashboardAgentsRoute
    }
  }
}

interface AuthLayoutRouteChildren {
  AuthLayoutLoginRoute: typeof AuthLayoutLoginRoute
}

const AuthLayoutRouteChildren: AuthLayoutRouteChildren = {
  AuthLayoutLoginRoute: AuthLayoutLoginRoute,
}

const AuthLayoutRouteWithChildren = AuthLayoutRoute._addFileChildren(
  AuthLayoutRouteChildren,
)

interface DashboardAgentsRouteChildren {
  DashboardAgentsNewRoute: typeof DashboardAgentsNewRoute
  DashboardAgentsIndexRoute: typeof DashboardAgentsIndexRoute
  DashboardAgentsAgentIdTestRoute: typeof DashboardAgentsAgentIdTestRoute
  DashboardAgentsAgentIdIndexRoute: typeof DashboardAgentsAgentIdIndexRoute
}

const DashboardAgentsRouteChildren: DashboardAgentsRouteChildren = {
  DashboardAgentsNewRoute: DashboardAgentsNewRoute,
  DashboardAgentsIndexRoute: DashboardAgentsIndexRoute,
  DashboardAgentsAgentIdTestRoute: DashboardAgentsAgentIdTestRoute,
  DashboardAgentsAgentIdIndexRoute: DashboardAgentsAgentIdIndexRoute,
}

const DashboardAgentsRouteWithChildren = DashboardAgentsRoute._addFileChildren(
  DashboardAgentsRouteChildren,
)

interface DashboardRouteChildren {
  DashboardAgentsRoute: typeof DashboardAgentsRouteWithChildren
  DashboardIndexRoute: typeof DashboardIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAgentsRoute: DashboardAgentsRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthLayoutRoute: AuthLayoutRouteWithChildren,
  DashboardRoute: DashboardRouteWithChildren,
  RedirectingRoute: RedirectingRoute,
  UnauthorizedRoute: UnauthorizedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
